import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { ImageModule } from 'primeng/image';

@Component({
  selector: 'app-events-gestor',
  standalone: true,
  imports: [ImageModule, CommonModule,RouterLink, RouterLinkActive, RouterOutlet],
  templateUrl: './events-gestor.component.html',
  styleUrl: './events-gestor.component.scss'
})
export class EventsGestorComponent {
  menuItems = [
    {
      title: 'Eventos',
      description:'Creación y gestiona de eventos de las diferentes modalidades',
      class: 'pi pi-calendar text-4xl text-green-500',
      routerLink: 'events',
    }
  ]
}
